import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { Cover } from "@/components/Cover";
import { Chapo, Promesses, Expertise, Realisations, Regie, Methode, FaqSection, useHomeContent } from "@/components/HomeSections";
import { ContactBlock } from "@/components/ContactBlock";

export default function HomePage() {
  const { data, isLoading, s } = useHomeContent();
  const location = useLocation();

  useEffect(() => {
    if (!data || !location.hash) return;
    let raf, tries = 0;
    const go = () => {
      const el = document.querySelector(location.hash);
      if (el) {
        if (window.__lenis) window.__lenis.scrollTo(el, { offset: -64, duration: 0.6 });
        else el.scrollIntoView({ behavior: "smooth" });
        return;
      }
      if (tries++ < 60) raf = requestAnimationFrame(go);
    };
    go();
    return () => cancelAnimationFrame(raf);
  }, [data, location.hash]);

  if (isLoading || !data) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }} data-testid="loading-home">
        <span className="t-logo" style={{ fontSize: 24 }}>SLI<span style={{ color: "var(--roi)" }}>Z</span></span>
      </div>
    );
  }

  const faqItems = s.faq?.items || [];
  return (
    <main data-testid="home-page">
      <Seo
        title={s.home?.seoTitle || "SLIZ"}
        description={s.home?.seoMeta || ""}
        path="/"
      />
      <Cover couverture={s.couverture} logos={s.logos} />
      <Chapo data={s.chapo} />
      <Promesses items={s.promesses} />
      <Expertise data={s.expertise} />
      <Regie data={s.canaux} />
      <Methode data={s.methode} />
      <Realisations sec={s.realisationsSec} projects={data.projects} />
      <ContactBlock contactSec={s.contactSec} />
      <FaqSection data={s.faq} />
    </main>
  );
}
